
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/series/[...terms]",
      function () {
        return require("private-next-pages/series/[...terms].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/series/[...terms]"])
      });
    }
  